import { mapValues } from 'lodash';
/**
 * Version 46 migrations registration summary widget - Air actuals
 * - Adding default configurations for air actuals on registration summary
 */
export default function v46(website) {
  return {
    ...website,
    eventVersion: 46,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'RegistrationSummary' && !layoutItem.config.airActualInformation) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            airActualInformation: {
              display: true,
              header: 'EventWidgets_AirActual_DefaultHeaderText__resx'
            },
            style: {
              ...layoutItem.config.style,
              airActualStyles: {
                totalPrice: {
                  styleMapping: 'text2',
                  customSettings: {
                    text: {
                      textAlign: 'left'
                    }
                  }
                },
                flightHeader: {
                  styleMapping: 'text1',
                  customSettings: {
                    text: {
                      textAlign: 'left'
                    },
                    background: {
                      color: 'primary'
                    },
                    spacing: {
                      padding: {
                        paddingBottom: 15,
                        paddingTop: 15,
                        paddingLeft: 15,
                        paddingRight: 15
                      }
                    }
                  }
                },
                confirmationNumberAndAirlines: {
                  styleMapping: 'text1',
                  customSettings: {
                    text: {
                      textAlign: 'left'
                    }
                  }
                },
                flightTimeAndAirports: {
                  styleMapping: 'text2'
                },
                flightDetails: {
                  styleMapping: 'body1',
                  customSettings: {
                    spacing: {
                      padding: {
                        paddingBottom: 30,
                        paddingTop: 30,
                        paddingLeft: 0,
                        paddingRight: 0
                      }
                    }
                  }
                },
                layover: {
                  styleMapping: 'body1',
                  customSettings: {
                    text: {
                      textAlign: 'left'
                    },
                    border: {
                      color: 'text',
                      thickness: 1,
                      borderStyle: 'dashed'
                    },
                    spacing: {
                      padding: {
                        paddingBottom: 20,
                        paddingTop: 20,
                        paddingLeft: 15,
                        paddingRight: 15
                      }
                    }
                  }
                },
                passengerNoteHeader: {
                  styleMapping: 'text2',
                  customSettings: {
                    text: {
                      textAlign: 'left'
                    }
                  }
                },
                passengerNoteText: {
                  styleMapping: 'body1',
                  customSettings: {
                    text: {
                      textAlign: 'left'
                    }
                  }
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
